<template>
  <div>
    <!-- 移动端遮罩层 -->
    <transition name="sidebar-fade">
      <div class="sidebar-overlay" v-if="mobileOpen" @click="closeMobileSidebar"></div>
    </transition>
    <!-- 侧边栏 -->
    <div class="sidebar" :class="{ 'sidebar-mobile-open': mobileOpen, 'sidebar-mobile': isMobile }">
      <el-menu :default-active="n" class="sidebar-el-menu" background-color="#fff" text-color="#000"
        active-text-color="#20a0ff" @select="handleSelect" :collapse="isCollapse">
        <el-menu-item index="1">
          <i class="el-icon-menu"></i>
          <span>系统首页</span>
        </el-menu-item>
        <el-menu-item index="2">
          <i class="el-icon-user"></i>
          <span>用户管理</span>
        </el-menu-item>
        <el-menu-item index="3">
          <i class="el-icon-shopping-bag-2"></i>
          <span>商品管理</span>
        </el-menu-item>
        <el-menu-item index="4">
          <i class="el-icon-box"></i>
          <span slot="title">订单管理</span>
          <span slot="title" class="span-tips" style="margin-left: 5px;"
            v-if="dingdan > 0">{{ dingdan }}</span>
        </el-menu-item>
        <el-menu-item index="5">
          <i class="el-icon-position"></i>
          <span>买家秀</span>
        </el-menu-item>
        <el-menu-item index="6">
          <i class="el-icon-s-grid"></i>
          <span>分类管理</span>
        </el-menu-item>
        <el-menu-item index="7">
          <i class="el-icon-setting"></i>
          <span>系统设置</span>
        </el-menu-item>
      </el-menu>
    </div>
  </div>
</template>

<script>
export default {
  name: "Sidebar",
  data() {
    return {
      n: sessionStorage.getItem("n") || '1',
      isCollapse: false,
      qx: 2,
      dingdan: 0,
      isMobile: false,
      mobileOpen: false
    };
  },
  mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
  },
  watch: {
    // 监听订单提醒
    "$store.state.remind"(newValue, oldValue) {
      this.dingdan = newValue.num > 99 ? '99+' : newValue.num
    }
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth < 768;
      if (!this.isMobile) {
        this.mobileOpen = false;
      }
    },
    openMobileSidebar() {
      if (this.isMobile) {
        this.mobileOpen = true;
      }
    },
    closeMobileSidebar() {
      this.mobileOpen = false;
    },
    handleSelect(key) {
      sessionStorage.setItem("n", key);
      // 手机端点击菜单后自动关闭侧边栏
      if (this.isMobile) {
        this.closeMobileSidebar();
      }
      if (key == "1") {
        this.$router.push("/dashboard").catch((err) => { });
      } else if (key == "2") {
        this.$router.push("/userAdm").catch((err) => { });
      } else if (key == "3") {
        this.$router.push("/goodAdm").catch((err) => { });
      } else if (key == "4") {
        this.$router.push("/orderAdm").catch((err) => { });
      } else if (key == "5") {
        this.$router.push("/showsAdm").catch((err) => { });
      } else if (key == "6") {
        this.$router.push("/classifyAdm").catch((err) => { });
      } else if (key == "7") {
        this.$router.push("/setting").catch((err) => { });
      }
    },
  },
  created() {
    this.$bus.$on("tt", (data) => {
      this.isCollapse = data;
    });
    // 订单提醒
    const order_num = localStorage.getItem("order_num")
    this.dingdan = order_num > 99 ? '99+' : order_num
  },
};
</script>

<style scoped>
.iconfont {
  margin-left: 2px;
  margin-right: 10px;
}

.sidebar {
  display: block;
  position: absolute;
  left: 0;
  top: 72px;
  bottom: 0;
  overflow-y: scroll;
  transition: transform 0.3s ease;
}

.sidebar::-webkit-scrollbar {
  width: 0;
}

.sidebar-el-menu:not(.el-menu--collapse) {
  width: 250px;
}

.sidebar > ul {
  height: 100%;
}

.span-tips {
  background-color: coral;
  width: 22px !important;
  height: 22px !important;
  border-radius: 50%;
  display: inline-table;
  line-height: 22px;
  text-align: center;
  font-size: 12px;
  color: #ffff;
}

/* ---- 移动端侧边栏抽屉 ---- */
.sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

.sidebar-fade-enter-active,
.sidebar-fade-leave-active {
  transition: opacity 0.3s ease;
}
.sidebar-fade-enter,
.sidebar-fade-leave-to {
  opacity: 0;
}

.sidebar-mobile {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 1000;
  transform: translateX(-100%);
  transition: transform 0.3s ease;
}

.sidebar-mobile.sidebar-mobile-open {
  transform: translateX(0);
}

/* 平板端适配 */
@media (min-width: 768px) and (max-width: 1024px) {
  .sidebar {
    top: 56px;
  }
}

/* 手机端适配 */
@media (max-width: 767px) {
  .sidebar {
    top: 0;
    padding-top: 56px;
  }
  .sidebar-el-menu:not(.el-menu--collapse) {
    width: 220px;
  }
}
</style>
